import { makeStyles } from '@mui/styles'
import EditorTabs from 'components/DocumentDetail/Editor/EditorTabs'
import Base from 'components/DocumentDetail/Editor/OcrBuilder/Base'
import { DocumentBuilder } from 'entities/DocumentsOcrBuilder'

interface Props {
  docDetail: DocumentBuilder
}

const useStyles = makeStyles({
  editor: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    height: '100%',
    overflow: 'hidden',
  },
})

export default function OcrBuilder({ docDetail }: Props) {
  const classes = useStyles()
  return (
    <div className={classes.editor}>
      <EditorTabs labels={['基本情報']}>
        <Base docDetail={docDetail} />
      </EditorTabs>
    </div>
  )
}
